import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from 'components/ui/Header';
import Sidebar from 'components/ui/Sidebar';
import Icon from 'components/AppIcon';
import UserTable from './components/UserTable';
import UserDetailPanel from './components/UserDetailPanel';
import FilterToolbar from './components/FilterToolbar';
import BulkActions from './components/BulkActions';
import AddUserModal from './components/AddUserModal';
import AuditLogModal from './components/AuditLogModal';
import BulkUpdateModal from './components/BulkUpdateModal';

const UserManagement = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [loading, setloading] = useState(true);
  const [bulkActionLoading, setBulkActionLoading] = useState("");
  const [actiontype, setActionType] = useState("")
  const [permissions, setPermissions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showAuditLogModal, setShowAuditLogModal] = useState(false);
  const [showBulkUpdateModal ,setShowBulkUpdateModal] = useState(false);
  const [filters, setFilters] = useState({
    search: '',
    role: 'all',
    permission: 'all',
    status: 'all'
  });

  const [currentUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user'))
    } catch (error) {
      return null
    }
  });

  const fetchPermission = async () => {
    const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/permission`, {
      method: "GET",
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    }
    )
    const availablePermissions = await response.json()
    setPermissions(availablePermissions)
    setloading(false)
    return availablePermissions
  }
  // console.log(permissions)

  const haspermission = (permName) => {
    return permissions.some(p => p.name === permName);
  }

  const fetchUsers = async () => {
    try {
      const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/user-data`);
      const data = await response.json();
      setUsers(data); // Set users state with the fetched data
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  useEffect(() => {
    if (currentUser) fetchPermission(currentUser);
  }, [currentUser?.email]);

  useEffect(() => {
    if (permissions.length > 0 || !loading) {
      const condition = haspermission("User Management")
      console.log(permissions)
      // console.log(condition)
      if (!condition) {
        navigate("/admin")
      }
    }
  }, [permissions])

  // Mock user data
  const [users, setUsers] = useState([]);
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/user-data`);
        const data = await response.json();
        setUsers(data); // Set users state with the fetched data
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);




  // Filter users based on current filters
  const filteredUsers = users.filter(user => {
    const matchesSearch = user.company_name.toLowerCase().includes(filters.search.toLowerCase()) ||
      user.email.toLowerCase().includes(filters.search.toLowerCase());
    const matchesRole = filters.role === 'all' || user.role === filters.role;
    const matchesStatus = filters.status === 'all' || user.status === filters.status;

    return matchesSearch && matchesRole && matchesStatus;
  });

  const handleUserSelect = (userId) => {
    setSelectedUsers(prev =>
      prev.includes(userId)
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const handleSelectAll = () => {
    if (selectedUsers.length === filteredUsers.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(filteredUsers.map(user => user.id));
    }
  };

  const handleUserClick = (user) => {
    setSelectedUser(user);
  };

  const handleAddUser = (userData) => {
    const newUser = {
      id: users.length + 1,
      ...userData,
      lastActivity: new Date(),
      login_history: [],
      activity_log: []
    };
    setUsers(prev => [...prev, newUser]);
    setShowAddUserModal(false);
  };

  const handleUpdateUser = (updatedUser) => {
    setUsers(prev => prev.map(user =>
      user.id === updatedUser.id ? updatedUser : user
    ));
    setSelectedUser(updatedUser);
  };
  const handleDeleteUser = (deletedUserId) => {
    setUsers(prev => prev.filter(u => u.id !== deletedUserId))
    setSelectedUser(null);
  }

  const handleBulkAction = async (action) => {
    if (bulkActionLoading) return;
    console.log(`Performing ${action} on users:`, selectedUsers);
    // Implement bulk actions here

    if (action === 'activate') {
      try {
        setBulkActionLoading(action);
        const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/bulkActive/`, {
          method: 'PUT',
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "users": selectedUsers })
        })
        if (response.ok) {
          setSelectedUsers([]);
          setSelectedUser((prev) => prev ? { ...prev, status: "Active" } : prev);
          await fetchUsers();
        }
      } finally {
        setBulkActionLoading("");
      }
    }
    if (action === 'deactivate') {
      try {
        setBulkActionLoading(action);
        const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/bulkDeactivate/`, {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ "users": selectedUsers })
        })
        if (response.ok) {
          setSelectedUsers([]);
          await fetchUsers();
        }
      } finally {
        setBulkActionLoading("");
      }
    }
    if (action === 'change-role') {
      setActionType("rolechange")
      setShowBulkUpdateModal(true)

    }
    // if (action === 'update-permissions') {
    //   const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/bulkPermissionsUpdate/`, {
    //     method: 'PUT',
    //     headers: {
    //       Authorization: `Bearer ${token}`
    //     },
    //     body: JSON.stringify({ "users": selectedUsers })
    //   })
    //   if (response.ok) {
    //     setSelectedUsers([]);
    //   }
    // }
    if (action === 'send-invite') {
      try {
        setBulkActionLoading(action);
        const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/bulkInvite/`, {
          method: 'POST',
          headers: {
            "content-type":"application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "users": selectedUsers })
        })
        if (response.ok) {
          setSelectedUsers([]);
        }
      } finally {
        setBulkActionLoading("");
      }
    }
    if (action === 'export') {
      try {
        setBulkActionLoading(action);
        const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/bulkExport/`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "users": selectedUsers })
        })
        if (response.ok) {
          setSelectedUsers([]);
        }
      } finally {
        setBulkActionLoading("");
      }
    }
    if (action === 'delete') {
      try {
        setBulkActionLoading(action);
        const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/bulkdelete/`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "users": selectedUsers })
        })
        if (response.ok) {
          setSelectedUsers([]);
        }
      } finally {
        setBulkActionLoading("");
      }
    }

    // setSelectedUsers([]);
  };

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const downloadcsv = () =>{
    if(!filteredUsers || filteredUsers.length === 0){
      alert("No User to Export");
      return
    }
    const headers= Object.keys(filteredUsers[0]);
    const rows = filteredUsers.map(user => headers.map(header =>{
      let value = user[header] ?? "";
      if(header.toLowerCase().includes("phone")){
        value = `${value}`
      }
      console.log("i am called")
      return JSON.stringify(value)}).join(","))
    const csvContent = [headers.join(","), ...rows].join("\n")

    const blob = new Blob([csvContent],{type:"text/csv;charset=utf-8"});
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url,
    link.setAttribute("download","user.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header
        user={currentUser}
        onMenuToggle={toggleSidebar}
        sidebarCollapsed={sidebarCollapsed}
      />

      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={toggleSidebar}
        permissions={permissions} // 👈 instead of userRole
      />

      <main className={`pt-header-height nav-transition ${sidebarCollapsed ? 'lg:pl-sidebar-collapsed' : 'lg:pl-sidebar-width'
        }`}>
        <div className="p-6">
          {/* Page Header */}
          <div className="mb-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6">
              <div>
                <h1 className="text-3xl font-heading font-bold text-text-primary mb-2">User Management</h1>
                <p className="text-text-secondary">Manage team members, roles, and permissions across your organization</p>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 mt-4 lg:mt-0">
                {haspermission('Audit Logs') &&
                  <button
                    onClick={() => setShowAuditLogModal(true)}
                    className="px-4 py-2 bg-surface border border-border text-text-primary rounded-lg hover:bg-background nav-transition flex items-center space-x-2"
                  >
                    <Icon name="FileText" size={16} color="var(--color-text-primary)" />
                    <span>Audit Log</span>
                  </button>
                }
                {haspermission('User Management') &&
                  <button
                    onClick={() => setShowAddUserModal(true)}
                    className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary-700 nav-transition flex items-center space-x-2"
                  >
                    <Icon name="UserPlus" size={16} color="white" />
                    <span>Add User</span>
                  </button>
                }
              </div>
            </div>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
              <div className="bg-surface rounded-lg p-4 border border-border">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-text-secondary">Total Users</p>
                    <p className="text-2xl font-bold text-text-primary">{users.length}</p>
                  </div>
                  <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
                    <Icon name="Users" size={20} color="var(--color-primary)" />
                  </div>
                </div>
              </div>

              <div className="bg-surface rounded-lg p-4 border border-border">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-text-secondary">Active Users</p>
                    <p className="text-2xl font-bold text-success">{users.filter(u => u.status === 'Active').length}</p>
                  </div>
                  <div className="w-10 h-10 bg-success-100 rounded-lg flex items-center justify-center">
                    <Icon name="UserCheck" size={20} color="var(--color-success)" />
                  </div>
                </div>
              </div>

              <div className="bg-surface rounded-lg p-4 border border-border">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-text-secondary">Clients</p>
                    <p className="text-2xl font-bold text-accent">{users.filter(u => u.role === 'Client').length}</p>
                  </div>
                  <div className="w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center">
                    <Icon name="Crown" size={20} color="var(--color-accent)" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filter Toolbar */}
          <FilterToolbar
            filters={filters}
            onFiltersChange={setFilters}
            userCount={filteredUsers.length}
            downloadcsv={downloadcsv}
          />

          {/* Bulk Actions */}
          {selectedUsers.length > 0 && (
            <BulkActions
              selectedCount={selectedUsers.length}
              onBulkAction={handleBulkAction}
              onClearSelection={() => setSelectedUsers([])}
              loadingAction={bulkActionLoading}
            />
          )}

          {/* Main Content */}
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
            {/* User Table */}
            <div className="xl:col-span-2">
              <UserTable
                users={filteredUsers}
                selectedUsers={selectedUsers}
                onUserSelect={handleUserSelect}
                onSelectAll={handleSelectAll}
                onUserClick={handleUserClick}
                selectedUser={selectedUser}
              />
            </div>

            {/* User Detail Panel */}
            <div className="xl:col-span-1">
              <UserDetailPanel
                user={selectedUser}
                onUpdateUser={handleUpdateUser}
                haspermission={haspermission}
                onDeleteUser={handleDeleteUser}
              />
            </div>
          </div>
        </div>
      </main>

      {/* Modals */}
      {showAddUserModal && (
        <AddUserModal
          onClose={() => setShowAddUserModal(false)}
          onAddUser={handleAddUser}
        />
      )}

      {showAuditLogModal && (
        <AuditLogModal
          onClose={() => setShowAuditLogModal(false)}
          users={users}
        />
      )}

      {showBulkUpdateModal &&
        <BulkUpdateModal
          onClose={() => setShowBulkUpdateModal(false)}
          onSuccess={async()=>{ setSelectedUsers([]);setSelectedUser(null); await fetchUsers();}}
          actiontype={actiontype}
          list={selectedUsers}
          token={token}
        />
      }
    </div>
  );
};
export default UserManagement;
